import { render, staticRenderFns } from "./hot-table-edit-features.vue?vue&type=template&id=71542158&scoped=true&"
import script from "./hot-table-edit-features.vue?vue&type=script&lang=js&"
export * from "./hot-table-edit-features.vue?vue&type=script&lang=js&"
import style0 from "./hot-table-edit-features.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./hot-table-edit-features.vue?vue&type=style&index=1&id=71542158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71542158",
  null
  
)

export default component.exports